import { render, staticRenderFns } from "./VisibleColumns.vue?vue&type=template&id=81d80f70&scoped=true&"
import script from "./VisibleColumns.vue?vue&type=script&lang=js&"
export * from "./VisibleColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d80f70",
  null
  
)

export default component.exports